<template>
  <div class='container'>

    <router-view></router-view>

    <!-- <van-tabbar route>
      <van-tabbar-item icon="home-o" to='/'>首页</van-tabbar-item>
      <van-tabbar-item icon="chat-o" to='/question'>问答</van-tabbar-item>
      <van-tabbar-item icon="video-o" to='/video'>视频</van-tabbar-item>
      <van-tabbar-item icon="user-o" to='/user'>
        {{$store.state.tokenInfo.token?'我的':'未登陆'}}
      </van-tabbar-item>
    </van-tabbar> -->
  </div>
</template>

<script>
export default {
  name: 'Layout'
}
</script>

<style scoped lang='less'></style>
